function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CkanResourceFormatTraits from "../../../Traits/TraitsClasses/CkanResourceFormatTraits";
import CkanSharedTraits from "../../../Traits/TraitsClasses/CkanSharedTraits";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
export default class CkanDefaultFormatsStratum extends LoadableStratum(CkanSharedTraits) {
  duplicateLoadableStratum(_newModel) {
    return new CkanDefaultFormatsStratum();
  }
  get supportedResourceFormats() {
    return [{
      id: "GeoJson",
      formatRegex: "^geojson$",
      // Limit geojson files to 150 MB
      maxFileSize: 150,
      definition: {
        type: "geojson"
      }
    }, {
      id: "Shapefile",
      formatRegex: "shapefile|shp|zip (shp)",
      urlRegex: ".zip$",
      // Limit shapefiles to 100 MB
      maxFileSize: 100,
      definition: {
        type: "shp"
      }
    }, {
      id: "WMS",
      formatRegex: "^wms$",
      definition: {
        type: "wms"
      }
    }, {
      id: "ArcGIS MapServer",
      formatRegex: "^esri rest$|^arcgis geoservices rest api$",
      urlRegex: "MapServer",
      definition: {
        type: "esri-mapServer"
      }
    }, {
      id: "Czml",
      formatRegex: "^czml$",
      // Limit CZML files to 50 MB
      maxFileSize: 50,
      definition: {
        type: "czml"
      }
    }, {
      id: "ArcGIS FeatureServer",
      formatRegex: "^esri rest$|^arcgis geoservices rest api$",
      urlRegex: "FeatureServer",
      definition: {
        type: "esri-featureServer"
      }
    }, {
      id: "CSV",
      formatRegex: "^csv-geo-",
      definition: {
        type: "csv"
      }
    }, {
      id: "Kml",
      formatRegex: "^km[lz]$",
      // Limit KML files to 30 MB
      maxFileSize: 30,
      definition: {
        type: "kml"
      }
    }].map(format => createStratumInstance(CkanResourceFormatTraits, format));
  }
}
_defineProperty(CkanDefaultFormatsStratum, "stratumName", "ckanDefaultFormats");
StratumOrder.addDefaultStratum(CkanDefaultFormatsStratum.stratumName);